import { render, staticRenderFns } from "./KycAlert.vue?vue&type=template&id=2ded3fde"
import script from "./KycAlert.vue?vue&type=script&lang=js"
export * from "./KycAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports